import { Alert, Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { BLUE_TEXT, INTER, NAVY, PAGE_BACKGROUND, POPPINS, SLATE, cardSx, primaryButtonSx } from '../publicStyles';

const linkSx = { fontFamily: INTER, fontSize: 14, fontWeight: 600, color: BLUE_TEXT } as const;

// Teacher accounts are granted by VerbaSchola or a co-teacher invitation, not by self-registration,
// so the public teacher journey is a pilot request. This preview never sends anything.
export default function PublicPilotRequestPage() {
    const [email, setEmail] = React.useState('');
    const [complete, setComplete] = React.useState(false);

    return (
        <Box component="main" sx={{ flex: 1, backgroundColor: PAGE_BACKGROUND, px: 2, py: { xs: 4, sm: 7 } }}>
            <Box sx={{ maxWidth: 520, mx: 'auto' }}>
                <Box sx={{ ...cardSx, p: { xs: 3, sm: 4 }, boxShadow: '0 10px 30px rgba(22, 58, 99, 0.06)' }}>
                    {complete ? (
                        <Stack spacing={2}>
                            <Typography component="h1" sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 26, color: NAVY }}>
                                Thanks for your interest
                            </Typography>
                            <Alert severity="success" role="status">
                                Pilot request preview for {email}. Nothing was sent from this mockup.
                            </Alert>
                            <Typography sx={{ fontFamily: INTER, fontSize: 15, lineHeight: 1.6, color: SLATE }}>
                                We&apos;ll email you to set up a short demo and talk about a pilot for your class.
                            </Typography>
                            <Button component={RouterLink} to="/mockup/public" sx={primaryButtonSx}>Back to home</Button>
                        </Stack>
                    ) : (
                        <>
                            <Typography component="h1" sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 26, color: NAVY }}>
                                Request a pilot
                            </Typography>
                            <Typography sx={{ fontFamily: INTER, fontSize: 15, lineHeight: 1.6, color: SLATE, mt: 1 }}>
                                Tell us about your class. We&apos;ll set up a short demo and a teacher account for you.
                            </Typography>
                            <Stack component="form" spacing={2} sx={{ mt: 3 }}
                                onSubmit={(event: React.FormEvent) => { event.preventDefault(); setComplete(true); }}>
                                <TextField label="Your name" name="name" autoComplete="name" required fullWidth />
                                <TextField label="School email" name="email" type="email" autoComplete="email" required fullWidth
                                    value={email} onChange={event => setEmail(event.target.value)} />
                                <TextField label="School or institution" name="school" autoComplete="organization" required fullWidth />
                                <TextField label="Language you teach" name="language" defaultValue="Mandarin Chinese" required fullWidth />
                                <TextField label="Anything we should know? (optional)" name="message" fullWidth multiline minRows={3}
                                    helperText="For example: grade level, class size, or when you'd like to start." />
                                <Button type="submit" sx={primaryButtonSx}>Send request</Button>
                            </Stack>
                        </>
                    )}
                </Box>
                <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, textAlign: 'center', mt: 3 }}>
                    Prefer email?{' '}
                    <Link href="mailto:support@verbaschola.com" underline="hover" sx={{ ...linkSx, fontSize: 13 }}>support@verbaschola.com</Link>
                    {' · '}
                    Already have an account?{' '}
                    <Link component={RouterLink} to="/mockup/public/login" underline="hover" sx={{ ...linkSx, fontSize: 13 }}>Log in</Link>
                </Typography>
            </Box>
        </Box>
    );
}
